<template>
  <div>
    <SelfServicePanel />
  </div>
</template>

<script>
import SelfServicePanel from '../../components/services/SelfServicePanel.vue'

export default {
  name: 'ServicesPage',
  components: {
    SelfServicePanel
  }
}
</script>
